import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type { StyledCheckboxGroupRootProps } from './CheckboxGroup.types';

export const StyledCheckboxGroupRoot = styled('fieldset')<StyledCheckboxGroupRootProps>(
  ({ theme }) => {
    return {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.space[16],
      flexWrap: 'wrap',
    };
  },
  getAllStyledProps,
);
